export default "__VITE_ASSET__BvthW0XE__"